import axios from 'axios';

const API_URL = window.ENV_CONFIG?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configuration pour les requêtes avec FormData
const formApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Upload d'une facture
export const uploadInvoice = async (formData) => {
  const response = await formApi.post('/upload-invoice', formData);
  return response.data;
};

// Récupération des données d'une facture
export const getInvoiceData = async (invoiceId) => {
  const response = await api.get(`/invoice/${invoiceId}`);
  // Return the raw data structure, transformation will happen in the components
  return response.data;
};

// Génération du Factur-X
export const generateFacturX = async (invoiceId, invoiceData) => {
  const response = await api.post(`/generate-facturx/${invoiceId}`, invoiceData);
  return response.data;
};

// Téléchargement du Factur-X
export const downloadFacturX = async (invoiceId) => {
  // Utiliser window.open pour télécharger le fichier
  window.open(`${API_URL}/download-facturx/${invoiceId}`, '_blank');
  return true;
};

export default api;
